exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-avatar img{height:25px!important;width:25px!important}.v-list__tile{height:100%!important}.list__tile:hover{background-color:#d3d3d3}.pagination__buttons{justify-content:center}.pagination__button{font-size:30px!important}.events__span{display:flex;align-items:center}.events__container .layout:not(.pagination__buttons){display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52ac63a3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Events.vue
// module id = 1388
// module chunks = 0